/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Care_Log_NoteInputs */

const vi_care_log_note = /** @type {(inputs: Care_Log_NoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ghi chú`)
};

/**

* @param {Care_Log_NoteInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const care_log_note = /** @type {((inputs?: Care_Log_NoteInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Care_Log_NoteInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_care_log_note(inputs)
});